<script>
export default {
    name: "synchronize-playback-setting",
    props: {
        disabled: Boolean,
        value: {}
    },
    computed: {
        label() {
            return Lang.langGet("Sync settings");
        },
        hint() {
            return Lang.langGet("Check system requirements in hardware.ini.");
        },
        items() {
            return [
                {value: 0, text: Lang.langGet("Disabled")},
                {value: 1, text: Lang.langGet("Sync across players")},
                {value: 2, text: Lang.langGet("Interactive list")},
            ];
        },
    }
}
</script>

<template>
    <v-select-custom
        :value="value"
        @input="$emit('input', $event)"
        :label="label"
        :hint="hint"
        :disabled="disabled"
        :items="items"
    />
</template>

